var _a;
import { UnitSuffix } from '../../defs';
import { CENTIMETER_PIXEL_VALUE, INCH_PIXEL_VALUE, MILLIMETER_PIXEL_VALUE, PICA_PIXEL_VALUE, POINT_PIXEL_VALUE, QUARTER_PIXEL_VALUE } from '../../internal/constants';
import { noConvert } from '../../internal/converters';
var pixelToCentimeter = function (value) {
    return value / CENTIMETER_PIXEL_VALUE;
};
var pixelToMillimeter = function (value) {
    return value / MILLIMETER_PIXEL_VALUE;
};
var pixelToQuarter = function (value) {
    return value / QUARTER_PIXEL_VALUE;
};
var pixelToInch = function (value) {
    return value / INCH_PIXEL_VALUE;
};
var pixelToPica = function (value) {
    return value / PICA_PIXEL_VALUE;
};
var pixelToPoint = function (value) {
    return value / POINT_PIXEL_VALUE;
};
var pixelToREM = function (value, options) {
    return value / options.remPixelValue();
};
var pixelToEM = function (value, options) {
    return value / options.emPixelValue();
};
var pixelToViewWidth = function (value, options) {
    return value / options.viewWidthPixelValue() * 100;
};
var pixelToViewHeight = function (value, options) {
    return value / options.viewHeightPixelValue() * 100;
};
var pixelToViewMin = function (value, options) {
    return value / Math.min(options.viewWidthPixelValue(), options.viewHeightPixelValue()) * 100;
};
var pixelToViewMax = function (value, options) {
    return value / Math.max(options.viewWidthPixelValue(), options.viewHeightPixelValue()) * 100;
};
export var pixel = (_a = {},
    _a[UnitSuffix.Pixel] = noConvert,
    _a[UnitSuffix.Centimeter] = pixelToCentimeter,
    _a[UnitSuffix.Millimeter] = pixelToMillimeter,
    _a[UnitSuffix.Quarter] = pixelToQuarter,
    _a[UnitSuffix.Inch] = pixelToInch,
    _a[UnitSuffix.Pica] = pixelToPica,
    _a[UnitSuffix.Point] = pixelToPoint,
    _a[UnitSuffix.REM] = pixelToREM,
    _a[UnitSuffix.EM] = pixelToEM,
    _a[UnitSuffix.ViewWidth] = pixelToViewWidth,
    _a[UnitSuffix.ViewHeight] = pixelToViewHeight,
    _a[UnitSuffix.ViewMin] = pixelToViewMin,
    _a[UnitSuffix.ViewMax] = pixelToViewMax,
    _a);
//# sourceMappingURL=pixel.js.map